import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

/**
 * Custom PrimeNG Theme for Pure BI Application
 * Based on the existing color scheme from styles.css
 * 
 * Primary Colors: Dark blue (#06152b, #122744)
 * Accent Colors: Blue (#0753f7, #0051ff)
 * Text: White on dark backgrounds
 */
export const CustomTheme = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '#5bd9ff', // Main primary color from your app
      600: '#92d7ec', // Accent blue from your app
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}'
    },
    colorScheme: {
      light: {
        primary: {
          color: '#5bd9ff',
          contrastColor: '#ffffff',
          hoverColor: '#5bd9ff',
          activeColor: '#5bd9ff'
        },
        highlight: {
          background: '#5bd9ff',
          focusBackground: '#5bd9ff',
          color: '#ffffff',
          focusColor: '#ffffff'
        },
        surface: {
          0: '#ffffff',
          50: '{zinc.50}',
          100: '{zinc.100}',
          200: '{zinc.200}',
          300: '{zinc.300}',
          400: '{zinc.400}',
          500: '{zinc.500}',
          600: '{zinc.600}',
          700: '{zinc.700}',
          800: '{zinc.800}',
          900: '{zinc.900}',
          950: '{zinc.950}'
        },
        formField: {
          background: '#ffffff',
          disabledBackground: '{zinc.200}',
          filledBackground: '{zinc.50}',
          filledHoverBackground: '{zinc.50}',
          filledFocusBackground: '{zinc.50}',
          borderColor: '{zinc.300}',
          hoverBorderColor: '{zinc.400}',
          focusBorderColor: '#5bd9ff',
          invalidBorderColor: '{red.400}',
          color: '{zinc.700}',
          disabledColor: '{zinc.500}',
          placeholderColor: '{zinc.500}',
          invalidPlaceholderColor: '{red.600}',
          floatLabelColor: '{zinc.500}',
          floatLabelFocusColor: '#92d7ec',
          floatLabelActiveColor: '{zinc.500}',
          floatLabelInvalidColor: '{red.600}',
          iconColor: '{zinc.400}',
          shadow: '0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(18, 18, 23, 0.05)'
        }
      },
      dark: {
        primary: {
          color: '#5bd9ff',
          contrastColor: '#ffffff',
          hoverColor: '#5bd9ff',
          activeColor: '#5bd9ff'
        },
        highlight: {
          background: '#5bd9ff',
          focusBackground: '#5bd9ff',
          color: '#ffffff',
          focusColor: '#ffffff'
        },
        surface: {
          0: '#06152b',      // Primary dark background
          50: '#122744',     // Secondary dark background
          100: '#1a3052',
          200: '#233a60',
          300: '#2c446e',
          400: '#354e7c',
          500: '#3e588a',
          600: '#4e6994',    // Header background
          700: '#546074',    // Table header
          800: '#303f57',    // Active nav/tab background
          900: '#06152b',    // Primary dark
          950: '#05152a'
        },
        text: {
          color: '#ffffff',
          hoverColor: '#ffffff',
          mutedColor: 'rgba(255, 255, 255, 0.6)',
          hoverMutedColor: 'rgba(255, 255, 255, 0.8)'
        }
      }
    },
    focusRing: {
      width: '2px',
      style: 'solid',
      color: '#5bd9ff',
      offset: '2px',
      shadow: 'none'
    }
  }
});
